import { Modal, Text, ActionButton } from 'components/commons';
import { DriverStatus } from 'enums';
import { useApi } from 'hooks';
import locale from 'localization';
import React, { useCallback } from 'react';
import styles from './users-status-modal.module.scss';
import { handleRequest } from 'utils';
import { updateUser } from 'apis/user.api';

const VehicleStatusModal = ({ refetchUsers, userId, firstName, status, close, active }) => {
  const { request: updateUserRequest, loading: updatingUser } = useApi({
    api: updateUser
  });

  const updateStatusCb = useCallback(async () => {
    const newStatus = status === DriverStatus.Active ? DriverStatus.Inactive : DriverStatus.Active;

    handleRequest(async () => {
      await updateUserRequest({ userId, status: newStatus }, () => updateStatusCb());
      refetchUsers();
      close();
    });
  }, [status, userId, updateUserRequest, refetchUsers, close]);

  const deactivateText = (
    <locale.Populate text={locale.youAreAboutDeactivateDriver} items={[<strong>{firstName}</strong>, firstName]} />
  );

  const activateText = (
    <locale.Populate text={locale.youAreAboutReactivateDriver} items={[<strong>{firstName}</strong>, firstName]} />
  );

  return (
    <Modal
      active={active}
      title={status === DriverStatus.Active ? locale.askDeactivateUser : locale.askReactivateUser}
      close={close}
      className={styles.modal}
    >
      <div className={styles.content}>
        <Text align="center">{status === DriverStatus.Active ? deactivateText : activateText}</Text>
      </div>
      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: close
          },
          {
            loading: updatingUser,
            onClick: updateStatusCb,
            text: status === DriverStatus.Active ? locale.yesDeactivateIt : locale.yesReactivateIt
          }
        ]}
      />
    </Modal>
  );
};

export default VehicleStatusModal;
